// extracted by mini-css-extract-plugin
export var header = "_fz-0";